export const DUMMY_LEADS_DATA = [
  {
    "id": 1,
    "origId": 2,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Najat Nasser",
    "email": "aquamarine_1976@hotmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 2,
    "origId": 3,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Jane",
    "email": "Janegrima@iprimus.com.au",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 3,
    "origId": 4,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Rachel",
    "email": "ulurujoy2468@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 4,
    "origId": 5,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Kylie Todd",
    "email": "Kylietodd29@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 5,
    "origId": 6,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Iffath",
    "email": "pritomi@live.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 6,
    "origId": 7,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Knockdown Rebuild",
    "name": "Arti Mishra",
    "email": "misharti@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 7,
    "origId": 8,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Knockdown Rebuild",
    "name": "Jess Hallbert",
    "email": "jessag89@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 8,
    "origId": 9,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Knockdown Rebuild",
    "name": "Ash Pataky",
    "email": "ashleighpataky@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 9,
    "origId": 10,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Becc Dwyer",
    "email": "becc.dwyer@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 10,
    "origId": 11,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Stuti Francis",
    "email": "stuti_francis14@yahoo.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 11,
    "origId": 12,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Rosetta Costa",
    "email": "motifsembroidery@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 12,
    "origId": 13,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Joanita de Sousa",
    "email": "jfcds2015@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 13,
    "origId": 14,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Brooke",
    "email": "Brookeestreich@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 14,
    "origId": 15,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "House & Land Package",
    "name": "Chloe",
    "email": "chloeccaldwell@yahoo.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 15,
    "origId": 16,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Monikah Naseri",
    "email": "monikah.naseri@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 16,
    "origId": 17,
    "date": "2025-09-04",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Alison Polkinghorne",
    "email": "alisonpolk@netspeed.com.au",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 17,
    "origId": 18,
    "date": "2025-09-05",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Rachel Dryden",
    "email": "rachel.dryden@hotmail.com.au",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 18,
    "origId": 19,
    "date": "2025-09-05",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Louisa Obst",
    "email": "louisa.obst@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 19,
    "origId": 20,
    "date": "2025-09-06",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Vikki Dahl",
    "email": "Vdahl@iinet.net.au",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 20,
    "origId": 21,
    "date": "2025-09-06",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Knockdown Rebuild",
    "name": "Natasha R Garner",
    "email": "natasha.r.garner@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 21,
    "origId": 22,
    "date": "2025-09-06",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Farm House Construction",
    "name": "Marguerite Evans",
    "email": "marguerite.evans@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 22,
    "origId": 23,
    "date": "2025-09-07",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "House & Land Package",
    "name": "Manisha Khadka",
    "email": "manishakhadka729@gmail.com",
    "phone": "",
    "comment": "Had a meeting today created a whatsapp group helping them to find a land in Macnamara  15-09-2025",
    "source": "Meta Ad"
  },
  {
    "id": 23,
    "origId": 24,
    "date": "2025-09-07",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Knockdown Rebuild",
    "name": "Katherine Watt",
    "email": "katherinewatt1@hotmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 24,
    "origId": 25,
    "date": "2025-09-08",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Connie Blanco-Maningo",
    "email": "Marimaningo@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 25,
    "origId": 26,
    "date": "2025-09-09",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "House & Land Package",
    "name": "Kunsang Dorjee",
    "email": "kundo_4@yahoo.com",
    "phone": "",
    "comment": "10/09 - Umang in touch and meeting scheduled",
    "source": "Meta Ad"
  },
  {
    "id": 26,
    "origId": 27,
    "date": "2025-09-10",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Josefine Andersson",
    "email": "moe.goe@yahoo.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 27,
    "origId": 28,
    "date": "2025-09-11",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "George",
    "email": "gapoulos@hotmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 28,
    "origId": 29,
    "date": "2025-09-12",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Mary-Anne Krnc",
    "email": "smkrnc@bigpond.net.au",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 29,
    "origId": 30,
    "date": "2025-09-13",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "",
    "name": "Caitlin Rossi",
    "email": "caitlin.rossi@hotmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 30,
    "origId": 4,
    "date": "2025-09-13",
    "agent": "Sahil",
    "status": "Moved to BuilderTrend",
    "inquiry": "I Am Looking To View A 3 Bedroom House/Townhouse Under 1M.",
    "name": "Swikriti Neupane",
    "email": "swikriti.neupane@gmail.com",
    "phone": "404126355",
    "comment": "",
    "source": "Website"
  },
  {
    "id": 31,
    "origId": 31,
    "date": "2025-09-14",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Knockdown Rebuild",
    "name": "Mick Lanihcra",
    "email": "michael.archinal@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 32,
    "origId": 2,
    "date": "2025-09-14",
    "agent": "Umang",
    "status": "Spam",
    "inquiry": "",
    "name": "Imogene Waterhouse",
    "email": "imogene.waterhouse63@gmail.com",
    "phone": "498604473",
    "comment": "",
    "source": "Website"
  },
  {
    "id": 33,
    "origId": 3,
    "date": "2025-09-14",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Enquiring About The Cost To Build Signature 280.1",
    "name": "Sangita Pathak",
    "email": "mehdadprincess@gmail.com",
    "phone": "432885462",
    "comment": "",
    "source": "Website"
  },
  {
    "id": 34,
    "origId": 32,
    "date": "2025-09-15",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Display Home",
    "name": "Lucy Curtis",
    "email": "lucyannecurtis@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 35,
    "origId": 33,
    "date": "2025-09-15",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Farm House Construction",
    "name": "Kathleen Harvey",
    "email": "kathleen.neesa.harvey@proton.me",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 36,
    "origId": 34,
    "date": "2025-09-16",
    "agent": "Sahil",
    "status": "Contacted",
    "inquiry": "House & Land Package",
    "name": "Hunter Ashley Smith",
    "email": "hunterashleysmith@gmail.com",
    "phone": "",
    "comment": "16/09/2025 Sahil: Client contacted via email. No response.",
    "source": "Meta Ad"
  },
  {
    "id": 37,
    "origId": 5,
    "date": "2025-09-18",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Hi We Wanted To Check The Feasibility And Cost Of Adding A Second Storey To Our Current Single Storey House In Taylor.",
    "name": "Salma Mithani",
    "email": "salmamithani@hotmail.com",
    "phone": "",
    "comment": "Umang reply",
    "source": "Website"
  },
  {
    "id": 38,
    "origId": 1,
    "date": "2025-09-20",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "",
    "name": "Junella Digo",
    "email": "bdjunella@yahoo.com.au",
    "phone": "402531824",
    "comment": "",
    "source": "REA"
  },
  {
    "id": 39,
    "origId": 35,
    "date": "2025-09-22",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Taylor Display",
    "name": "Kristy Griffin",
    "email": "kristylee.griffin@gmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 40,
    "origId": 36,
    "date": "2025-09-22",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Taylor Display",
    "name": "Elena Sands",
    "email": "maria71092@hotmail.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 41,
    "origId": 37,
    "date": "2025-09-22",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Taylor Display",
    "name": "Fadiah Habaibeh",
    "email": "fadiahabaibeh@yahoo.com",
    "phone": "",
    "comment": "Email Done by Umang",
    "source": "Meta Ad"
  },
  {
    "id": 42,
    "origId": 6,
    "date": "2025-09-22",
    "agent": "Sahil",
    "status": "Moved to BuilderTrend",
    "inquiry": "Current Fire Damaged Home Rebuild",
    "name": "Marius Schoeman",
    "email": "mariusschoeman@yahoo.com.au",
    "phone": "408410356",
    "comment": "22/09/2025 Sahil: Called client but he hung up as he was occupied in a meeting. Details sent on email.",
    "source": "Website"
  },
  {
    "id": 43,
    "origId": 7,
    "date": "2025-09-22",
    "agent": "Umang",
    "status": "Sold  Contract Signed",
    "inquiry": "Hi, We Are Interested In Any Information You Have On The",
    "name": "Bethany Wrenn",
    "email": "bethany.81@hotmail.com",
    "phone": "468859602",
    "comment": "",
    "source": "Website"
  },
  {
    "id": 44,
    "origId": 38,
    "date": "2025-09-23",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "House & Land Package",
    "name": "Sonam Deki",
    "email": "451238426",
    "phone": "451238426",
    "comment": "Lead via Organic Social media",
    "source": "Meta Ad"
  },
  {
    "id": 45,
    "origId": 39,
    "date": "2025-09-23",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Taylor Display",
    "name": "Susan Bolton",
    "email": "susan75rose@gmail.com",
    "phone": "61438295628",
    "comment": "",
    "source": "Meta Ad"
  },
  {
    "id": 46,
    "origId": 8,
    "date": "2025-09-23",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Bought Hose In Frome St Griffith Cnsidering Knock Down And Buld",
    "name": "Peter Kittel",
    "email": "peter.kittel@axisenergy.com.au",
    "phone": "488764724",
    "comment": "Email was send and enter the details in Buildertrend",
    "source": "Website"
  },
  {
    "id": 47,
    "origId": 40,
    "date": "2025-09-24",
    "agent": "Sahil",
    "status": "Contacted",
    "inquiry": "Visit Googong Display",
    "name": "Marguerite Evans",
    "email": "marguerite.evans@gmail.com",
    "phone": "61405577063",
    "comment": "Call not answered. Left a voice message.",
    "source": "Meta Ad"
  },
  {
    "id": 48,
    "origId": 41,
    "date": "2025-09-24",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "House & Land Package",
    "name": "Bryan Arcadio Asence",
    "email": "asence_bryan@yahoo.com",
    "phone": "",
    "comment": "",
    "source": "Meta Ad"
  },
  {
    "id": 49,
    "origId": 42,
    "date": "2025-09-24",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Visit Taylor Display",
    "name": "Louisa Obst",
    "email": "louisa.obst@gmail.com",
    "phone": "61405243350",
    "comment": "2025-09-26T04:18:47+0000 Visit Taylor Display /raw",
    "source": "Meta Ad"
  },
  {
    "id": 50,
    "origId": 9,
    "date": "2025-09-24",
    "agent": "Umang",
    "status": "Moved to BuilderTrend",
    "inquiry": "Good Day!",
    "name": "Bryan Asence",
    "email": "asence_bryan@yahoo.com",
    "phone": "405720309",
    "comment": "",
    "source": "Website"
  }
];
